import { render, staticRenderFns } from "./CreateUserModal.vue?vue&type=template&id=5e8d27ff&scoped=true"
import script from "./CreateUserModal.vue?vue&type=script&lang=js"
export * from "./CreateUserModal.vue?vue&type=script&lang=js"
import style0 from "./CreateUserModal.vue?vue&type=style&index=0&id=5e8d27ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e8d27ff",
  null
  
)

export default component.exports